import { kmm } from './kmm';
import { RecordEvent } from '@norlys-a-s/norlys-play-kmm';

export async function startRecording(
  sid: number,
  eventId: number,
  seriesRecording = false
): Promise<RecordEvent> {
  if (seriesRecording) {
    const result = kmm((repo) => repo.recordSeries(sid, eventId));
    return result;
  }
  return kmm((repo) => repo.recordEvent(sid, eventId));
}

export default startRecording;
